module.exports = __webpack_public_path__ + "img/product-ketang-zzct-05.5a411276.png";